module.exports = __webpack_public_path__ + "static/Grupo533-e44bc007048b7daa481d1d255287b827.png";